'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _utils = require('../utils');

var _ramda = require('ramda');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function accessors(target) {
  target.accessors = (0, _extends3.default)({}, target.accessors, {
    data: function data(_data) {
      return _data || [];
    },
    datapoints: function datapoints(serie) {
      return (0, _ramda.pipe)((0, _ramda.propOr)([], 'datapoints'), (0, _ramda.reject)(function (dp) {
        return (0, _ramda.isNil)(dp.y);
      }))(serie);
    },
    lastDatapoint: function lastDatapoint(serie) {
      return (0, _ramda.last)(target.accessors.datapoints(serie));
    },
    yRange: function yRange(base) {
      return base.xScale.range();
    },
    annotationDatapoint: function annotationDatapoint(options, datum) {
      return (0, _utils.getFormat)(options.format.datapoint)(datum.y);
    },
    isCondensed: function isCondensed(options, serie, scale) {
      var datapoints = target.accessors.datapoints(serie);
      var datapointsCount = (0, _ramda.length)(datapoints);
      var datapointsXPositions = (0, _ramda.map)(function (dp) {
        return scale(target.accessors.x(dp));
      }, datapoints);
      var datapointsXExtent = [Math.min.apply(Math, (0, _toConsumableArray3.default)(datapointsXPositions)), Math.max.apply(Math, (0, _toConsumableArray3.default)(datapointsXPositions))];
      var rangeDelta = (0, _utils.getRangeDelta)(datapointsXExtent);
      var ratio = rangeDelta / Math.max(1, datapointsCount);
      return ratio < options.line.densityRatio;
    }
  });
}
exports.default = accessors;